import React, { useContext, useState, useEffect, useRef } from 'react';
import { map, sortBy, reverse } from 'lodash';
import classnames from 'classnames';
import { FocusBaseContext } from '../contexts';
import renderRawHtml from '../../../../common/render_raw_html';
import ImageInPopup from '../../../../common/components/image_in_popup';

const SwipeData = () => {
  const { currentSummary, openReport, reportPath } = useContext(FocusBaseContext);

  const sorting = useRef({ by: '', dir: '' });
  const currentSorting = sorting.current;
  const [ sortedConcepts, setSortedConcepts ] = useState(() => (currentSummary.report.concepts));

  const filterStr = () => (
    map(
      currentSummary.filter,
      (el) => (`filter[]=${encodeURIComponent(el)}`)
    ).join('&')
  );
  const xlsParams = (reportName) => {
    const data = [ `report=${reportName}` ];
    if (currentSummary.filter && currentSummary.filter.length > 0) {
      data.push(filterStr());
    }
    return data.join('&');
  };

  const handleExportClick = (event) => {
    openReport(event);
  };

  const respondentsDataExportPath = `${reportPath}?${xlsParams('data')}`;
  const likesDislikesExportPath = `${reportPath}?${xlsParams('likes')}`;

  const sortConcepts = (newConceptsList) => {
    let newSortedConcepts = newConceptsList || sortedConcepts;
    newSortedConcepts = sortBy(newSortedConcepts, currentSorting.by);
    if (currentSorting.dir === 'desc') {
      newSortedConcepts = reverse(newSortedConcepts);
    }
    setSortedConcepts([ ...newSortedConcepts ]);
  };

  const changeSorting = (field) => {
    if (currentSorting.by === field) {
      currentSorting.dir = (currentSorting.dir === 'desc' ? 'asc' : 'desc');
    } else {
      currentSorting.by = field;
      currentSorting.dir = 'desc';
    }
    sortConcepts();
  };

  const handleSortByDislikes = (event) => {
    event?.preventDefault();
    changeSorting('disliked_percent');
  };

  const handleSortByLikes = (event) => {
    event?.preventDefault();
    changeSorting('liked_percent');
  };

  const handleSortByName = (event) => {
    event?.preventDefault();
    changeSorting('name');
  };

  const handleSortByAvgDuration = (event) => {
    event?.preventDefault();
    changeSorting('avg_duration');
  };

  useEffect(() => {
    handleSortByLikes();
  }, []);

  useEffect(() => {
    sortConcepts(currentSummary.report.concepts);
  }, [ currentSummary ]);

  return (
    <>
      <div className="page-section -flex-between swipe-section">
        <h3>Swipe Results</h3>
        <div>
          <a
            className="button -outline"
            href={ respondentsDataExportPath }
            onClick={ handleExportClick }
          >
            Export XLS Respondents Data
          </a>
          <a
            className="button -outline"
            href={ likesDislikesExportPath }
            onClick={ handleExportClick }
          >
            Export XLS Like/Dislike Rates
          </a>

        </div>
      </div>

      <div className="page-section summary-swipe">
        <div className="summary-swipe_row">
          <div className="summary-swipe_col">
            <div className="summary-swipe_icon">
              <svg className="icon -summary-time"><use xlinkHref="#svg_summary-time" /></svg>
            </div>
            <div className="summary-swipe_title">
              { currentSummary.report.avg_duration || 'N/A' }
            </div>
            <div className="summary-swipe_description">
              Average Total Time Spent <br />(Swiping Only)
            </div>
          </div>
          <div className="summary-swipe_col" />
          <div className="summary-swipe_col">
            <div className="summary-swipe_icon">
              <svg className="icon -summary-users"><use xlinkHref="#svg_summary-users" /></svg>
            </div>
            <div className="summary-swipe_title">
              { currentSummary.report.total_respondents }
            </div>
            <div className="summary-swipe_description">Total Respondents</div>
          </div>
        </div>

        <div className="summary-swipe_row">
          <div className="summary-swipe_col" style={ { color: currentSummary.colors.negative } }>
            <button className="summary-swipe_sort -dislike" onClick={ handleSortByDislikes }>
              <span
                className={
                  classnames(
                    "summary-swipe_sort_title",
                    { '-asc': currentSorting.by === 'disliked_percent' && currentSorting.dir === 'asc' },
                    { '-desc': currentSorting.by === 'disliked_percent' && currentSorting.dir === 'desc' },
                  )
                }
              >
                <svg className="icon -dislike summary-swipe_sort_icon">
                  <use xlinkHref="#svg_dislike" />
                </svg>
                <span { ...renderRawHtml(currentSummary.negative_text) } />
              </span>
              <span className="summary-swipe_sort_desc">Negative</span>
            </button>
          </div>
          <div className="summary-swipe_col">
            <button className="summary-swipe_sort -concepts">
              <span
                className={
                  classnames(
                    "summary-swipe_sort_title",
                    { '-asc': currentSorting.by === 'name' && currentSorting.dir === 'asc' },
                    { '-desc': currentSorting.by === 'name' && currentSorting.dir === 'desc' }
                  )
                }
                onClick={ handleSortByName }
              >
                Concepts
              </span>
              <span
                className={
                  classnames(
                    "summary-swipe_sort_desc",
                    { '-asc': currentSorting.by === 'avg_duration' && currentSorting.dir === 'asc' },
                    { '-desc': currentSorting.by === 'avg_duration' && currentSorting.dir === 'desc' }
                  )
                }
                onClick={ handleSortByAvgDuration }
              >
                avg time<br />to swipe concepts
              </span>
            </button>
          </div>
          <div className="summary-swipe_col" style={ { color: currentSummary.colors.positive } }>
            <button className="summary-swipe_sort -like" onClick={ handleSortByLikes }>
              <span
                className={
                  classnames(
                    "summary-swipe_sort_title",
                    { '-asc': currentSorting.by === 'liked_percent' && currentSorting.dir === 'asc' },
                    { '-desc': currentSorting.by === 'liked_percent' && currentSorting.dir === 'desc' },
                  )
                }
              >
                <span { ...renderRawHtml(currentSummary.positive_text) } />
                <svg className="icon -like summary-swipe_sort_icon">
                  <use xlinkHref="#svg_like" />
                </svg>
              </span>
              <span className="summary-swipe_sort_desc">Positive</span>
            </button>
          </div>
        </div>

        <div className="summary-swipe_row -sm">
          <div className="summary-swipe_col">
            {
              map(sortedConcepts, (concept) => (
                <div
                  key={ `left-${concept.id}` }
                  className="summary-swipe_rate -dislike"
                  style={ { color: currentSummary.colors.negative } }
                >
                  <div className="summary-swipe_rate_title">
                    { concept.disliked_percent }% ({ concept.disliked_count })
                  </div>
                  <div className="summary-swipe_rate_bar">
                    <div
                      className="summary-swipe_rate_bar_value"
                      style={ { width: `${concept.disliked_percent}%` } }
                    />
                  </div>
                </div>
              ))
            }
          </div>
          <div className="summary-swipe_col">
            {
              map(sortedConcepts, (concept) => (
                <div className="summary-swipe_concept" key={ `center-${concept.id}` }>
                  <span className="concept-name">{ concept.name }</span>
                  <div className="summary-swipe_concept_image">
                    <ImageInPopup
                      scrollMargin
                      className="-pointer"
                      customZIndex={ 1062 }
                      src={ concept.src }
                    >
                      <img className="-pointer" src={ concept.src } alt={ concept.name } />
                    </ImageInPopup>
                  </div>
                  { concept.avg_duration } seconds
                </div>
              ))
            }
          </div>
          <div className="summary-swipe_col">
            {
              map(sortedConcepts, (concept) => (
                <div
                  key={ `right-${concept.id}` }
                  className="summary-swipe_rate -like"
                  style={ { color: currentSummary.colors.positive } }
                >
                  <div className="summary-swipe_rate_title">
                    { concept.liked_percent }% ({ concept.liked_count })
                  </div>
                  <div className="summary-swipe_rate_bar">
                    <div
                      className="summary-swipe_rate_bar_value"
                      style={ { width: `${concept.liked_percent}%` } }
                    />
                  </div>
                </div>
              ))
            }
          </div>
        </div>
      </div>
    </>
  );
};

export default SwipeData;
